/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BeneficiaryDto
 */
export interface BeneficiaryDto {
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    personId: string;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeneficiaryDto
     */
    displayName: string;
    /**
     * 
     * @type {number}
     * @memberof BeneficiaryDto
     */
    order: number;
}

/**
 * Check if a given object implements the BeneficiaryDto interface.
 */
export function instanceOfBeneficiaryDto(value: object): value is BeneficiaryDto {
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function BeneficiaryDtoFromJSON(json: any): BeneficiaryDto {
    return BeneficiaryDtoFromJSONTyped(json, false);
}

export function BeneficiaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeneficiaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'displayName': json['displayName'],
        'order': json['order'],
    };
}

export function BeneficiaryDtoToJSON(json: any): BeneficiaryDto {
    return BeneficiaryDtoToJSONTyped(json, false);
}

export function BeneficiaryDtoToJSONTyped(value?: BeneficiaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'displayName': value['displayName'],
        'order': value['order'],
    };
}

